import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams} from "@angular/http";
import {
    BASE_CONSTANTS,
    ITCIApplication,
    ITCIApplicationDeployResponse,
    ITCIApplicationTenancyRequest,
    ITCIApplicationTenancyResponse,
    SERVICE_URLS,
    TCIApplicationTenancyAction,
    TCITenantAppType,
    ITCIApplicationDeploymentProvider
} from "@tci/common";

import { TciTenantModelService } from "../../ng-tenant/tci-tenant.model";
import { Observable } from "rxjs";

@Injectable()
export class BaseAppHMReplaceService {

    constructor(
        private http: Http,

        private tenantModelSvc: TciTenantModelService
        ) {

    }

    /**
     * Get source app list, owned by same user as target app
     */
    getSourceAppList(userId: string): Observable<ITCIApplication[]> {
        return this.http.get(`${SERVICE_URLS.TENANCY_USERS}/${userId}${BASE_CONSTANTS.APPS}`)
            .map((rsp: Response) =>  rsp.json());
    }





    replaceApp(appType: TCITenantAppType, appId: string, sourceAppId: string): Observable<ITCIApplicationTenancyResponse> {

        const reqParam: ITCIApplicationTenancyRequest = {
            tenantType: appType,
            tenantAction: TCIApplicationTenancyAction.TENANT_REPLACE_APPLICATION,
            appId,
            replaceSourceAppId: sourceAppId
        };
        return this.http.post(SERVICE_URLS.TENANCY, reqParam)
            .map((response: Response) => response.json() );
    }

    getAppStatus(appId: string, desiredInstance: number): Observable<ITCIApplicationDeployResponse> {
        const queryParams = new URLSearchParams();
        queryParams.append("desiredInstanceCount", desiredInstance.toString());
        return this.http.get(`${SERVICE_URLS.TENANCY_STATUS}/${appId}`, {search: queryParams})
            .map((rsp: Response) =>  rsp.json());
    }

    getTenantDeployProvider(tenantType: TCITenantAppType): ITCIApplicationDeploymentProvider {
        return this.tenantModelSvc.getTenant(tenantType).getAppDeploymentProvider();
    }

}
